/**
 * IWHC Countdown Timer
 * Persists remaining time in sessionStorage so it survives page navigation
 */
(function() {
  'use strict';

  const STORAGE_KEY = 'iwhc_countdown_end';

  function getOrCreateEndTime(durationMinutes) {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      const endTime = parseInt(stored, 10);
      if (endTime > Date.now()) return endTime;
    }
    const endTime = Date.now() + (durationMinutes || 75) * 60 * 1000;
    sessionStorage.setItem(STORAGE_KEY, endTime.toString());
    return endTime;
  }

  function formatTime(ms) {
    if (ms <= 0) return '0:00:00';
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    return h + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }

  function initUrgencyCountdown() {
    const el = document.getElementById('urgency-countdown');
    if (!el) return;

    const section = el.closest('[data-countdown-minutes]');
    const minutes = section ? parseInt(section.dataset.countdownMinutes, 10) : 75;
    const endTime = getOrCreateEndTime(minutes);

    function tick() {
      const remaining = endTime - Date.now();
      el.textContent = formatTime(remaining);
      if (remaining > 0) requestAnimationFrame(tick);
    }

    tick();
    setInterval(function() {
      const remaining = endTime - Date.now();
      el.textContent = formatTime(remaining);
    }, 1000);
  }

  function initDeliveryCountdown() {
    const timerNumbers = document.querySelectorAll('.delivery-timer .timer-number');
    if (timerNumbers.length < 3) return;

    const endTime = getOrCreateEndTime(75);

    setInterval(function() {
      const remaining = Math.max(0, endTime - Date.now());
      const totalSec = Math.floor(remaining / 1000);
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;
      timerNumbers[0].textContent = String(h).padStart(2, '0');
      timerNumbers[1].textContent = String(m).padStart(2, '0');
      timerNumbers[2].textContent = String(s).padStart(2, '0');
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initUrgencyCountdown();
      initDeliveryCountdown();
    });
  } else {
    initUrgencyCountdown();
    initDeliveryCountdown();
  }
})();
